/**
 * ACL ke DB / saved names (acl_modules, acl_settings) aur panel (sidebar) ke naam alag hain.
 * DB aur saved ACL JSON ko hum nahi badalte (purane ACL aur Java wala old panel inhi naamo par chalte hain).
 * - ACL screen par naam panel wale dikhte hain.
 * - Code panel wale naam se bhi permission check kar sakta hai (hasPermission fallback).
 * Koi naam yahan nahi hai to wo jaisa hai waisa hi dikhega aur check hoga.
 */

/** DB parent module  ->  sidebar group label */
export const ACL_PARENT_LABELS: Record<string, string> = {
  'Manage Users': 'Users',
  'Manage Dialers': 'Dialers',
  'Manage Campaign': 'Campaigns',
  'Manage CLI': 'CLI Pool',
  'Manage API CLI': 'API CLI',
  'Manage Api Key': 'API Keys',
  'Manage Groups': 'Groups',
  'Manage Locations': 'Locations',
  'Manage Trunks': 'Trunks',
  'Voice Plans': 'Voice Pricing',
  'TTS Plans': 'TTS Pricing',
  'Voice Library': 'Library',
  'Server Monitoring': 'Health',
  'Flash Messages': 'Announcements',
};

/** DB parent module -> { DB child name -> sidebar label } */
export const ACL_CHILD_LABELS: Record<string, Record<string, string>> = {
  'Manage Users': {
    'User List': 'Directory',
    'Reseller Summary': 'Billing Summary',
    'Credit History': 'Credit Ledger',
    'Call Detail Records': 'Call Records',
    'User Settings List': 'Tier Pricing',
    'Voice Plan Logs': 'Plan Audit',
  },
  'Manage Dialers': {
    'Search Dialer': 'Search',
    'Dialer List': 'All Dialers',
    'Dialer Usage': 'Usage',
  },
  'Manage Campaign': {
    'Campaign Operations': 'Operations',
    'Voice Campaign Summary': 'All Campaigns',
    'Prompt Voice Campaign Summary': 'Prompt Campaigns',
    'Historical Campaign Summary': 'History',
    'Manage Campaigns': 'Allocation',
    'View Voice Base': 'Voice Base',
    'Download Report': 'Downloads',
    'Inbound Summary': 'All Inbound',
  },
  'TTS Studio': {
    'TTS Flow Approval': 'Approval',
    'TTS Flow Logs': 'Logs',
  },
  'Voice Library': {
    'Prompts for Approval': 'Pending IVR Prompts',
    'All Prompts': 'IVR Voice',
  },
  'Number Action': {
    'View Blacklist': 'Blacklist',
    'Manage Blacklist-DND': 'Blacklist & DND',
    'Manage Bulk Blacklist-DND': 'Bulk Blacklist & DND',
    'View Whitelist': 'Whitelist',
    'Search DND-Blist-Wlist': 'Lookup Number',
  },
  'Manage CLI': {
    'Allocate CLI': 'Allocate',
    'CLI List': 'All CLIs',
    'Pilot no. CLI': 'Pilots',
    'Archived CLI List': 'Archive',
  },
  'Manage API CLI': {
    'Api CLI List': 'All API CLIs',
    'Api Pilot no. CLI': 'Pilots',
    'Archived Api CLI List': 'Archive',
  },
  'Manage Api Key': {
    'Api Summary': 'Usage',
    'Api Historical Summary': 'History',
  },
};

/** ACL screen par parent ka display naam. */
export function aclParentLabel(parent: string): string {
  return ACL_PARENT_LABELS[parent] ?? parent;
}

/** ACL screen par child ka display naam. */
export function aclChildLabel(parent: string, child: string): string {
  return ACL_CHILD_LABELS[parent]?.[child] ?? child;
}

/** Panel wale naam (jaise "Directory") se DB key ("User List") nikalta hai. Nahi mila to wahi naam. */
export function aclChildKey(parent: string, label: string): string {
  const map = ACL_CHILD_LABELS[parent];
  if (!map) return label;
  for (const [key, shown] of Object.entries(map)) {
    if (shown === label) return key;
  }
  return label;
}